/* === VERIFY DIAMOND PRICE === */
(function checkDiamondPrice() {
  try {
    const shopifyData = localStorage.getItem('selected-diamond-shopify-data');
    if (!shopifyData) return;

    const selectedDiamond = JSON.parse(shopifyData);
    if (!selectedDiamond) return;

    const variants = selectedDiamond.variants || selectedDiamond.product?.variants;
    if (!variants?.length) return;

    const diamondProductInfo = {
      diamond_productId:   String(selectedDiamond.id || selectedDiamond.product?.id || ''),
      diamond_variantId:   String(variants[0].id),
      diamond_retailPrice: '$' + variants[0].price,
      diamondTitle:        selectedDiamond.title || selectedDiamond.product?.title || ''
    };

    if (!diamondProductInfo.diamond_productId) return;

    fetch(`${portalApiUrl}/verify_diamond_price`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(diamondProductInfo)
    })
    .then(r => r.json())
    .then(function (res) {
      if (res?.action === 'remove') {
        $('#rc-generic-popup-close').remove();
        $('#rc-generic-popup').find('.rc-popup-heading').text('The price of your diamond has changed.');
        $('#rc-generic-popup').find('.rc-popup-subtext').text('Please click continue to see the updated price.');
        $('#rc-generic-popup').find('.rc-popup-cta')
          .attr('id', 'rc-diamond-price-changed-cta')
          .text('CONTINUE');
        $('#rc-generic-popup').addClass('open');

        /* === On Continue: clear stale data and redirect to diamond feed === */
        $(document).one('click', '#rc-diamond-price-changed-cta', function () {
          clearBespokeSelectedData();
          $('#rc-generic-popup').removeClass('open');
          document.getElementById('rc-pre-cart-change-diamond')?.click();
        });
      }
    })
    .catch(err => console.error('RC: verify_diamond_price error:', err));

  } catch (e) {
    console.error('RC: checkDiamondPrice error:', e);
  }
})();